// Importiere den TranslocoService, um die Sprache zu wechseln
import { Component, inject, OnInit } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { MatFormFieldModule } from '@angular/material/form-field';

interface Language {
  code: string
  name: string // Wird im Dropdown angezeigt (z.B. "Deutsch")
  icon: string // Pfad zur Flagge oder Icon-Name
}

@Component({
  selector: 'pixl-language-switcher',
  imports: [
    TranslocoModule,
    MatSelectModule,
    MatFormFieldModule,
  ],
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent implements OnInit {
  private translocoService = inject(TranslocoService);

  availableLangs: Language[] = [
    { code: 'de', name: 'Deutsch', icon: 'assets/flags/de.svg' },
    { code: 'en', name: 'English', icon: 'assets/flags/gb.svg' },
  ];

  currentLang!: string;
  currentLangName!: string;

  ngOnInit(): void {
    this.currentLang = this.translocoService.getActiveLang();
    this.currentLangName = this.getLanguageName(this.currentLang);
  }

  get currentFlagIcon(): string {
    const lang = this.availableLangs.find(l => l.code === this.currentLang);
    return lang ? lang.icon : '';
  }

  getLanguageName(code: string): string {
    const lang = this.availableLangs.find(l => l.code === code);
    return lang ? lang.name : code.toUpperCase();
  }

  changeLanguage(langCode: string): void {
    this.translocoService.setActiveLang(langCode);
    this.currentLang = langCode;
    this.currentLangName = this.getLanguageName(langCode);
  }
}
